import React from 'react';
import { FormField, Select, ISelectProps } from '@cian/ui-kit';

export interface IRealtorRatingFieldRegion {
  options: ISelectProps['options'];
  value?: ISelectProps['value'];
  onChange?: ISelectProps['onChange'];
  disabled?: ISelectProps['disabled'];
}

/**
 * Филд Регион
 */
export const RealtorRatingFieldRegion = ({ value, options, disabled, onChange }: IRealtorRatingFieldRegion) => (
  <FormField label={'Регион'}>
    <Select size={'M'} value={value} options={options} disabled={disabled} onChange={onChange} />
  </FormField>
);
